var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvestment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Saving-Bag-Increase--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Saving Bag Increase Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.42 0h-4a0.49 0.49 0 0 0 -0.42 0.31 0.49 0.49 0 0 0 0.1 0.54l0.94 0.94a0.25 0.25 0 0 1 0 0.36l-6 6a1.25 1.25 0 0 0 0.89 2.13 1.21 1.21 0 0 0 0.88 -0.37l6 -6a0.27 0.27 0 0 1 0.36 0l0.93 0.94a0.51 0.51 0 0 0 0.36 0.15 0.43 0.43 0 0 0 0.19 0 0.5 0.5 0 0 0 0.31 -0.46V0.5a0.5 0.5 0 0 0 -0.54 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26 6.38a0.25 0.25 0 0 0 -0.19 -0.09H3.43a0.25 0.25 0 0 0 -0.19 0.09C2.1 7.7 0.08 10.39 0.08 12.83a6.17 6.17 0 0 0 12.34 0c0 -2.44 -2.02 -5.13 -3.16 -6.45Zm-2 9.09a0.23 0.23 0 0 0 -0.18 0.24v0.16a0.75 0.75 0 1 1 -1.5 0v-0.09a0.26 0.26 0 0 0 -0.25 -0.25h-0.3a0.75 0.75 0 0 1 0 -1.5h1.79a0.41 0.41 0 0 0 0.41 -0.41 0.4 0.4 0 0 0 -0.23 -0.38l-1.79 -0.72a1.91 1.91 0 0 1 0.21 -3.62 0.26 0.26 0 0 0 0.19 -0.24V8.5a0.75 0.75 0 0 1 1.5 0v0.08a0.25 0.25 0 0 0 0.25 0.25h0.3a0.75 0.75 0 1 1 0 1.5H5.89a0.42 0.42 0 0 0 -0.41 0.42 0.4 0.4 0 0 0 0.26 0.38l1.79 0.71a1.91 1.91 0 0 1 -0.24 3.63Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.68 2.42a0.87 0.87 0 0 0 0 -1 0.88 0.88 0 0 0 -1 -0.25 1.83 1.83 0 0 1 -2 -0.38L7.32 0.44a1.51 1.51 0 0 0 -2.14 0l-0.3 0.31a1.83 1.83 0 0 1 -2 0.38 0.88 0.88 0 0 0 -1 0.25 0.87 0.87 0 0 0 0 1l1.53 2.31a0.25 0.25 0 0 0 0.2 0.1h5.28a0.25 0.25 0 0 0 0.2 -0.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.67 19.75a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 1 0 -2.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.92 15.5h-8a2 2 0 0 0 -2 2V22a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2v-4.5a2 2 0 0 0 -2 -2Zm0 6.25a0.25 0.25 0 0 1 -0.25 0.25h-7.5a0.25 0.25 0 0 1 -0.25 -0.25v-4a0.25 0.25 0 0 1 0.25 -0.25h7.5a0.25 0.25 0 0 1 0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvestment);
export default ForwardRef;